/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#scanner-card[_ngcontent-%COMP%]{margin-top:0}.expand-toggle[_ngcontent-%COMP%]{margin-top:3px;cursor:pointer;color:var(--clr-link-color);float:right}"];
export { styles as styles };

